import type { ReactElement, ReactNode } from 'react';

import { Icon, flexClassNames } from '@spotify-internal/encore-web';
import {
  FilterChip,
  FilterViewerComponentProps,
} from '@spotify/confidence-core-react';

import { useWorkflowExtensions } from '../../hooks';
import { normalizeTypeId } from './TypeFilterEditor';

export const TypeFilterViewer = (
  props: FilterViewerComponentProps<string[]>,
): ReactElement => {
  const { value } = props;
  const extensions = useWorkflowExtensions();

  let label: ReactNode;

  if (!value || value.length === 0) {
    label = `No ${props.filter.label} selected`;
  } else if (value.length === 1) {
    const ext = extensions.find(
      w => normalizeTypeId(w.workflowId) === value[0],
    );
    const WorkflowIcon = ext?.workflowIcon;
    label = (
      <span
        className={flexClassNames({
          inline: true,
          alignItems: 'center',
          gap: 'tighter-2',
        })}
      >
        <span>{props.filter.label}:</span>{' '}
        {WorkflowIcon && (
          <Icon
            as={WorkflowIcon}
            size="small"
            semanticColor="textSubdued"
            aria-hidden
          />
        )}
        <span>{ext?.title ?? value[0]}</span>
      </span>
    );
  } else {
    label = `${props.filter.label}s (${value.length})`;
  }

  return <FilterChip {...props} label={label} />;
};
